import type { SignalTimeframe, SignalTimeframeConfig } from "../miscellaneous/SignalTimeframe";
import { SignalTimeframePeriod } from "../miscellaneous/SignalTimeframe";
import type TechnologySignalFilters from "./TechnologySignalFilters";

const technologySignalTimeframeConfig: SignalTimeframeConfig<TechnologySignalFilters> = {
    options: [
        {
            amount: 1,
            id: SignalTimeframePeriod.Day,
        },
        {
            amount: 1,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 2,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 3,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 1,
            id: SignalTimeframePeriod.Month,
        },
        {
            amount: 3,
            id: SignalTimeframePeriod.Month,
        },
        {
            amount: 6,
            id: SignalTimeframePeriod.Month,
        },
        {
            amount: 1,
            id: SignalTimeframePeriod.Year,
        },
    ],
    fromFilters(filters: Readonly<Partial<TechnologySignalFilters>>) {
        const { period, periodAmount } = filters;

        if (period == null || periodAmount == null) {
            return undefined;
        }

        return { amount: periodAmount, id: period };
    },
    toFilters(timeframe: Readonly<SignalTimeframe>) {
        return {
            period: timeframe.id as SignalTimeframePeriod,
            periodAmount: timeframe.amount,
        };
    },
};

export default technologySignalTimeframeConfig;
